/** SessionStorage: einmalig Dialog „Plan öffnen?“ überspringen (z. B. nach Neuanlage / „Wieder öffnen“). */
export const BSP_RIND_SKIP_PLAN_OEFFNEN_KEY = 'kiene_bsp_rind_skip_plan_oeffnen_confirm';

export function bspRindSetSkipPlanOeffnenBestaetigung(bsId: number): void {
    sessionStorage.setItem(BSP_RIND_SKIP_PLAN_OEFFNEN_KEY, String(bsId));
}
